import type { View } from '@/api/types'
import { byOrder } from '@/shared/lib/order'

/**
 * Which view of a table is being looked at.
 *
 * The same rule the shell applies to workspaces: a url that names one is the
 * authority. `?view=12` shows view 12 or it shows nothing -- falling back to
 * another would leave the tab title, the filters and the rows disagreeing with
 * the address bar, and the case is ordinary rather than hypothetical. A link to
 * a view somebody has since deleted is the everyday version of it.
 *
 * With no view named there is nothing to disagree with, so the first in the
 * table's own order wins. That is what a link from the sidebar means.
 */
export function resolveView(
  views: readonly View[],
  routeViewId: number | undefined,
): View | undefined {
  const ordered = byOrder(views)

  if (routeViewId !== undefined) {
    return ordered.find((view) => view.id === routeViewId)
  }

  return ordered[0]
}
